import React from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import { useDispatch, useSelector } from "react-redux"
import { prependAndPlay, playOrPause } from "../../stores/mediaPlayerSlice"
import { PauseCircle, PlayCircle } from "react-bootstrap-icons"
import { isMobile } from "react-device-detect"

interface Song {
  id: number
  title: string
  title_cleaned?: string
  post_type_nice?: string
  external_photo_src?: string
  published_at: string
  band_name: string
  parent_path?: string
  nada_path: string
}

interface SongSearchResultProps {
  song: Song
}

export const SongSearchResult: React.FC<SongSearchResultProps> = ({ song }) => {
  const dispatch = useDispatch()
  const onPlayClick = (e: React.MouseEvent) => {
    dispatch(prependAndPlay([song]))
  }
  const onPlayOrPauseClick = (e: React.MouseEvent) => {
    dispatch(playOrPause(song))
  }

  const currentMediaItem = useSelector(
    // @ts-ignore
    (state: any) => state.mediaPlayer.value.currentMediaItem,
  )
  // @ts-ignore
  const playerState = useSelector(
    (state: any) => state.mediaPlayer.value.playerState,
  )
  const isCurrentlyPlaying =
    playerState === "playing" && currentMediaItem?.postId === song.id

  return (
    <li className="col-span-1" style={{ height: "max-content" }}>
      <div
        style={{
          backgroundColor: "black",
          backgroundImage: song.external_photo_src ? `url(${song.external_photo_src})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          aspectRatio: "16/9",
          minHeight: isMobile ? "156px" : "unset",
        }}
        className="w-full overflow-hidden"
      >
        <div
          className="w-full h-full justify-center flex items-center"
          style={{
            background: "rgb(0,0,0,0.3)",
            paddingTop: isMobile ? "36px" : "unset",
            paddingBottom: isMobile ? "36px" : "unset",
          }}
        >
          {isCurrentlyPlaying ? (
            <PauseCircle
              className="text-white cursor-pointer"
              width="50%"
              height="50%"
              onClick={onPlayOrPauseClick}
            />
          ) : (
            <PlayCircle
              className="text-white cursor-pointer"
              width="50%"
              height="50%"
              onClick={onPlayClick}
            />
          )}
        </div>
      </div>

      <Link to={song.parent_path || song.nada_path}>
        <div className="font-bold leading-tight">
          {song.title_cleaned || song.title}
        </div>
        {song.post_type_nice && (
          <div className="font-medium leading-tight text-gray-600 text-xs uppercase">
            {song.post_type_nice}
          </div>
        )}
        <div className="text-gray-800 text-sm leading-tight">
          <span className="text-black-800 text-sm">
            {SmartDateFormat({
              dateStr: song.published_at,
              includeTime: false,
            })}
          </span>
          <span className="text-gray-800 text-sm leading-tight">
            {song.band_name}
          </span>
        </div>
      </Link>
    </li>
  )
}
